module.exports = __webpack_public_path__ + "img/model_2.2b632c2b.png";